const PT = require("prop-types");
const React = require("react");
const {CONFIRM_MODAL_SHAPE_COLORS} = require("../util/ColorUtil");

// Bevel polygons for the standard confirm-modal card (viewBox 0 0 430 198).
const SHADOW_POLYGONS = [
	"9.6,191 15.8,72.4 24,69.6 23.5,165 20.1,188.8",
	"2.1,2.5 306.3,9.1 427.9,1.3 406.7,27.2 401.1,112.4 417.9,186.3 81.8,179.4 13.9,183.4 19.3,67.8",
	"2.1,2.5 7.4,6.2 23.1,71 15.7,73",
	"422.7,196.7 82.5,187.6 9.3,191 18.5,182.1 326,162.8 414.7,183.7",
	"417.9,190.3 422.7,196.7 414.1,115.9 403.1,114.4",
	"427.9,1.3 414.3,118.1 402.7,114 418.7,10.3",
];

const FACE_POLYGON =
	"7.4,6.2 306.3,13.1 423.6,5.6 410.4,116.6 417.9,190.3 81.8,183.4 12.7,187.8 19.3,71.8";

// Inline SVG for the confirm modal card background (replaces per-style <img> files).
function ConfirmModalShape(props) {
	const {fillColor, shadowColor, styleType, className} = props;
	const palette =
		CONFIRM_MODAL_SHAPE_COLORS[styleType] || CONFIRM_MODAL_SHAPE_COLORS.default;
	const face = fillColor || palette.fill;
	const shadow = shadowColor || palette.shadow;

	return (
		<svg
			className={className}
			viewBox="0 0 430 198"
			preserveAspectRatio="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{SHADOW_POLYGONS.map((pts, i) => (
				<polygon key={i} fill={shadow} points={pts} />
			))}
			<polygon fill={face} points={FACE_POLYGON} />
		</svg>
	);
}

ConfirmModalShape.displayName = "ConfirmModalShape";

ConfirmModalShape.propTypes = {
	fillColor: PT.string,
	shadowColor: PT.string,
	styleType: PT.string,
	className: PT.string,
};

module.exports = ConfirmModalShape;
